module.exports = __webpack_public_path__ + "img/3.1.e675baf7.png";